/* eslint-disable no-undef */
import axios from 'axios';
import { notification } from 'antd';

export const titleUrl = 'Provider Portal | Eden Care';

// Extract the exact message the API returned, across the shapes used app-wide:
//  - axios error:      error.response.data.{message | api.message | error}
//  - fetch JSON body:  { message } | { api: { message } } | { error }
//  - network/JS error: Error.message
export const getApiMessage = (payload, fallback = 'Something went wrong. Please try again.') => {
  if (!payload) return fallback;
  return (
    payload?.response?.data?.message ||
    payload?.response?.data?.api?.message ||
    payload?.response?.data?.error ||
    payload?.message ||
    payload?.api?.message ||
    payload?.error ||
    fallback
  );
};

// Toast the exact API error message.
export const toastApiError = (payload, fallback) =>
  notification.error({ key: 'api-error', message: getApiMessage(payload, fallback) });

// Global safety net: surface a toast for ANY failed axios request (hospital +
// pharmacy), so no API failure is silent. Callers that expect an error (e.g. an
// empty-record lookup) can opt out with `{ skipErrorToast: true }` in the config.
// Session-expiry (401) is left to the auth/logout flow.
if (typeof axios !== 'undefined' && !axios.__errorToastRegistered) {
  axios.__errorToastRegistered = true;
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (!error?.config?.skipErrorToast && status !== 401) {
        notification.error({ key: 'api-error', message: getApiMessage(error) });
      }
      return Promise.reject(error);
    },
  );
}

export const baseURLv2 = 'https://service.edencaremedical.com/prod/api/v2';

const ProdURL = 'https://service.edencaremedical.com/prod/api/v1';
const QA_URL = 'https://service.edencaremedical.com/dev/api/v1';
const DEMO_URL = 'https://service.edencaremedical.com/dev/api/v1';
const UAT_URL = 'https://service.edencaremedical.com/uat/api/v1';
const STAGING_URL = 'https://service.edencaremedical.com/stage/api/v1';

export const baseUrl =
  // process.env.REACT_APP_VERCEL_ENV === 'production'
  //   ? ProdURL
  //   : process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === 'demo'
  //   ? DEMO_URL
  //   : process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === 'UAT'
  //   ? UAT_URL
  //   : process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === 'staging'
  //   ? STAGING_URL
  //   : QA_URL;


  UAT_URL